

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';
import { BaseDocument } from './../entities/basedocument.entity';
export class Delivery extends BaseDocument
{   
    public CustomerAddressID: number; 
    public TotalBeforeVat: number; 
    public TotalAfterVat: number; 
    public TotalBeforeVatOrigin: number; 
    public TotalAfterVatOrigin: number; 
    public DeliveryDate: Date; 
    public ObjType: number; 
    public ContactPersonName: string; 
    public CustomerFullAddress: string; 
    public ObjTypeString: string; 
	
}



